import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";
import { captureLabel } from "./capture-label";

export function describeGenerateImage(
  _record: Record<string, unknown>,
  state: ToolActivityState,
): ToolActivity {
  return captureLabel(
    {
      optionFailed: "Failed to generate an image",
      optionRunning: "Generating an image",
      optionDone: "Generated an image",
      failed: () => "Failed to generate an image",
      running: () => "Generating an image",
      done: () => "Generated an image",
    },
    state,
    { isOption: false, subject: null },
  );
}
